// import { WORDPRESS_API } from "shared/constants";

// export const getErasmusCategory = async ({ signal } = {}) => {
//   const response = await fetch(
//     `${WORDPRESS_API}/wp-json/wp/v2/categories?search=erasmus`,
//     { signal }
//   );

//   if (!response.ok) {
//     throw new Error("Nie udało się pobrać kategorii Erasmus.");
//   }

//   const categories = await response.json();

//   return categories.find(
//     category => category.slug?.toLowerCase() === "erasmus"
//   ) ?? categories[0] ?? null;
// };

// export const getLatestErasmusPost = async (categoryId, { signal } = {}) => {
//   const response = await fetch(
//     `${WORDPRESS_API}/wp-json/wp/v2/posts?categories=${categoryId}&per_page=1`,
//     { signal }
//   );

//   if (!response.ok) {
//     throw new Error("Nie udało się pobrać aktualności Erasmus.");
//   }

//   const posts = await response.json();

//   return posts[0] ?? null;
// };
import {
  WORDPRESS_API_JSON
} from "shared/constants";

export const getErasmusCategory = async ({
  signal
} = {}) => {
  const response = await fetch(
    `${WORDPRESS_API_JSON}/categories?search=erasmus`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(
      "Nie udało się pobrać kategorii Erasmus."
    );
  }

  const categories = await response.json();

  return (
    categories.find(
      (category) =>
        category.slug?.toLowerCase() === "erasmus"
    ) ??
    categories[0] ??
    null
  );
};

export const getLatestErasmusPost = async (
  categoryId,
  { signal } = {}
) => {
  const response = await fetch(
    `${WORDPRESS_API_JSON}/posts?categories=${categoryId}&per_page=1&_embed=1`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(
      "Nie udało się pobrać aktualności Erasmus."
    );
  }

  const posts = await response.json();

  return posts[0] ?? null;
};